import React from 'react';
import clsx from 'clsx';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { NextImage } from 'src/components/shared/elements/NextImage';
import styles from './index.module.scss';

type Props = {
  title: string;
  japaneseLowDesc: string;
  ageVerification: string;
  passportAgeVerification: string;
  reminderForAlcoholImportTaxExemptionLimit: string;
  sakeNotice: string;
  yesAge20: string;
  addToCartText: string;
  isCheck: boolean;
  onCheckboxChange: () => void;
  closeModal: () => void;
  onAddToCart: () => void;
};

export const Presenter: React.FC<Props> = ({
  title,
  japaneseLowDesc,
  ageVerification,
  passportAgeVerification,
  reminderForAlcoholImportTaxExemptionLimit,
  sakeNotice,
  yesAge20,
  addToCartText,
  isCheck,
  onCheckboxChange,
  onAddToCart,
  closeModal,
}) => (
  <CommonModal
    title={title}
    closeModal={closeModal}
    fixedElement={
      <div className={styles.wrap}>
        <div>■{sakeNotice}</div>
        <div className={styles.description}>
          <p>{japaneseLowDesc}</p>
          <p className={styles.strong}>{ageVerification}</p>
          <p>{passportAgeVerification}</p>
          <p className={styles.caution}>
            <span>※</span>
            {reminderForAlcoholImportTaxExemptionLimit}
          </p>
        </div>
        <div className={styles.confirmWrap}>
          <NextImage
            src="/kaimono/images/products/alcohol/alcohol-age-restriction.webp"
            width={160}
            height={160}
            alt=""
          />
        </div>
        <label className={styles.checkWrap} htmlFor="check">
          <input className={styles.checkbox} type="checkbox" checked={isCheck} onChange={onCheckboxChange} id="check" />
          <div className={styles.confirmYes}>{yesAge20}</div>
        </label>
        <div className={styles.buttonContainer}>
          <button
            className={clsx(styles.button, !isCheck && styles.disabled)}
            disabled={!isCheck}
            onClick={onAddToCart}
          >
            {addToCartText}
          </button>
        </div>
      </div>
    }
  />
);
